import React from "react";
import { Navigate } from "react-router-dom";
import ChatBox from "../components/ai/ChatBox";
import { useLanguage } from "../contexts/LanguageContext";
import { useLayout } from "../contexts/LayoutContext";
import { resolveFeatureSections } from "../utils/featureSections";
import "../styles/ai-assistant.css";

export default function AiAssistantPage() {
  const { lang } = useLanguage();
  const { settings, loadingSettings } = useLayout();
  const isAr = lang === "ar";
  const sections = resolveFeatureSections(settings);

  if (loadingSettings) {
    return null;
  }

  if (!sections.aiChat) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="ai-assistant-page" dir={isAr ? "rtl" : "ltr"}>
      <div className="container py-4 py-lg-5">
        <section className="ai-assistant-page__hero">
          <div className="ai-assistant-page__hero-copy">
            <span className="ai-assistant-page__eyebrow">
              {isAr ? "تجربة محادثة ذكية" : "Smart conversation experience"}
            </span>
            <h1 className="ai-assistant-page__title">
              {isAr ? "اسأل المساعد عن كل ما يخص حسابك والمنصة" : "Ask the assistant about your account and the platform"}
            </h1>
            <p className="ai-assistant-page__subtitle">
              {isAr
                ? "يمكنك متابعة الطلبات، استكشاف المنتجات والكورسات، وفهم السياسات من مكان واحد."
                : "Track orders, explore products and courses, and understand platform policies from one place."}
            </p>
          </div>

          <div className="ai-assistant-page__hero-card">
            <div className="ai-assistant-page__hero-stat">
              <strong>{isAr ? "طلباتك" : "Your orders"}</strong>
              <span>{isAr ? "اسأل عن الحالة والتتبع والتفاصيل." : "Ask about status, tracking, and details."}</span>
            </div>
            <div className="ai-assistant-page__hero-stat">
              <strong>{isAr ? "المحتوى" : "Content"}</strong>
              <span>{isAr ? "ابحث في السياسات والمدونة بسرعة." : "Search policies and blog content quickly."}</span>
            </div>
            <div className="ai-assistant-page__hero-stat">
              <strong>{isAr ? "الاقتراحات" : "Recommendations"}</strong>
              <span>{isAr ? "احصل على اقتراحات مرتبطة بما تبحث عنه." : "Get suggestions tailored to what you need."}</span>
            </div>
          </div>
        </section>

        <ChatBox lang={lang} />
      </div>
    </div>
  );
}
